import React from 'react';

import CompanyOfficeSelect from 'bundles/company/permissions/shared/company_office_select';
import OfficeBadge from 'bundles/company/permissions/shared/office_badge';

interface OfficeOption {
  value: number;
  label: string;
}

interface Props {
  options: OfficeOption[];
  selectedIds: number[];
  onChange: (ids: number[]) => void;
}

// The offices an office admin covers. They are not decoration: User validates that at least one is
// present whenever office_admin is on, so without this the row could be switched on but never saved.
//
// Built from the same pair office_admin_card uses, rather than a second chips-and-picker of its own.
export default function OfficeAdminField({ options, selectedIds, onChange }: Props) {
  const labelById = new Map(options.map(option => [option.value, option.label]));

  const available = options
    .filter(option => !selectedIds.includes(option.value))
    .map(option => ({ value: String(option.value), label: option.label }));

  return (
    <div className="d-flex gap-2 flex-wrap mt-2">
      {selectedIds.map(id => (
        <OfficeBadge
          key={id}
          officeName={labelById.get(id) ?? ''}
          onClick={() => onChange(selectedIds.filter(selected => selected !== id))}
        />
      ))}
      <div className="flex-grow-1">
        <CompanyOfficeSelect
          companyOfficeOptions={available}
          placeholder="Add an office"
          onChange={({ value }) => onChange([...selectedIds, parseInt(value, 10)])}
        />
      </div>
    </div>
  );
}
